var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0242 5.80469L32.2859 5.31041",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0242 16.4247L32.2859 16.9189",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0272 11.1147H35.5747",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.551 5.80469L4.28931 5.31041",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.551 16.4247L4.28931 16.9189",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5475 11.1147H1",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8166 31.3906V40.5H31.4491V24.6754H33.2414L29.1329 20.3074L25.0242 24.6754H26.8166V28.9713",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5378 28.5256L18.4292 24.1576L14.3206 28.5256H16.113V40.5H20.7454V28.5256H22.5378Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40831 37.9073V40.5H10.0408V32.6867H11.8331L7.72459 28.3188L3.61597 32.6867H5.40831V35.488",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2822 15.7036V14.3577",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2822 7.73047V6.38458",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3499 13.1279C16.3499 13.1279 16.6485 14.2598 18.1614 14.352C19.774 14.4502 20.2153 13.3063 20.2153 12.6129C20.2153 12.0256 19.9547 11.0875 18.2869 10.9034C16.9014 10.7505 16.6375 9.8477 16.6375 9.37472C16.6375 8.90173 16.9197 7.73052 18.2817 7.73052C19.4145 7.73052 19.8142 8.59915 19.8142 8.59915",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4909 5.45082C14.796 4.26687 16.5285 3.5455 18.4294 3.5455C22.4902 3.5455 25.7822 6.83743 25.7822 10.8982C25.7822 14.959 22.4902 18.251 18.4294 18.251C14.3686 18.251 11.0767 14.959 11.0767 10.8982C11.0767 9.62928 11.3981 8.43533 11.9641 7.39348",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03027 10.8985C8.03027 5.15567 12.6858 0.500184 18.4287 0.500184C24.1715 0.500184 28.827 5.15567 28.827 10.8985C28.827 16.6413 24.1715 21.2969 18.4287 21.2969C12.6858 21.2969 8.03027 16.6413 8.03027 10.8985Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseRevenue);
export default __webpack_public_path__ + "static/media/increase_revenue.5d310500918d93ef706c944574be9f70.svg";
export { ForwardRef as ReactComponent };